export const GET_STARTED_SLICE_TYPE = 'homegetstarted';
